// Earn Point On Blog Like Dislike.
const ArticleLikeWrapper = document.querySelectorAll('.article_like_or_dislike_container');
if(ArticleLikeWrapper.length > 0){
  ArticleLikeWrapper.forEach(wraper=>{
    const SubmitButtons = wraper.querySelectorAll('button[type="submit"]#like');
    if(SubmitButtons.length > 0){
      SubmitButtons.forEach(button=>{
        button.addEventListener('click', ()=>{
          window.TriggerCustomActionOfLoyaltyPoint();
        })
      })
    }
  })
}
window.TriggerCustomActionOfLoyaltyPoint = function(){
  const customActionName = "Like A Blog";  // Change this to your custom action name
  const proxyUrl = `${window.Rivo.global_config.proxy_paths.loy}/loy/customers/${window.Rivo.common.customer.id}/record_custom_action`;
  const data = { custom_action_name: customActionName };

  fetch(proxyUrl, {
    method: "POST",
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(function(response) {
    console.log('Custom action recorded:', response);
  })
  .catch(function(error) {
    console.error('Error recording custom action:', error);
  });
}